import { render, staticRenderFns } from "./user-dialog.vue?vue&type=template&id=cf08c4f6&"
import script from "./user-dialog.vue?vue&type=script&lang=js&"
export * from "./user-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports